import { useBodySetUp } from "./setup/body";
import { useStickyNav } from "./patterns/stickyNav";
import { useNavToggle } from "./patterns/navToggle";
import { useSubWraps } from "./patterns/subWraps";
import { useSliderBanner } from "./patterns/sliderBanner";
import { useParallax } from "./patterns/parallax";
import { usePopUpDialog } from "./patterns/popUpDialog";
import { useSearchModal } from "./patterns/searchModal";
import { useLogoBar } from "./patterns/logoBar";
import { usePostFilterForm } from "./patterns/postsFilter";
import { useAccordions } from "./patterns/accordions";
import { useVideoModal } from "./patterns/videoModal";
import { useReadMore } from "./patterns/readMore";

function init() {
  console.log("Spruce Start Theme Loaded");

  // Body Setup
  useBodySetUp();

  // Sticky Nav
  useStickyNav();

  // Nav Toggles
  useNavToggle();

  // SubWraps
  useSubWraps();

  // Slider Banner
  useSliderBanner();

  // Parallax
  useParallax();

  // Pop Up
  usePopUpDialog();

  // Search Modal
  useSearchModal();

  // Logo Bar
  useLogoBar();

  // Posts Filter Form
  usePostFilterForm();

  // Accordions
  useAccordions();

  // Video Modal
  useVideoModal();

  // Read More
  useReadMore();
}

document.addEventListener("DOMContentLoaded", init);
